export default __webpack_public_path__ + "static/media/property_58.de593a20.png";